// extracted by mini-css-extract-plugin
export default {"container":"CL-z","topReviewHeading":"DL-z","criticalReview":"EL-z","favorableReview":"FL-z","vsSeparator":"GL-z"};